<template>
  <div id="login">
    <div id="login__content" class="mt-10">
      <auth-forms-wrapper height="" width="448px" titleStyle="pb-1">
        <template #default>
          <div class="d-flex justify-center pb-6">
            <h6
              class="font-weight-large secondary--font subtitle-1 text--primary"
            >
              {{ $dictionary.app.loginForm.subTitle }}
            </h6>
          </div>

          <login-form />
          <div class="pt-6 text-center">
            <router-link
              id="forgot-password-link"
              class="text-decoration-none"
              :to="$paths.forgotPassword"
            >
              <strong class="subtitle-1 black--text"> Forgot Password</strong>
            </router-link>
          </div>
        </template>
      </auth-forms-wrapper>
    </div>
  </div>
</template>

<script>
import { AuthFormsWrapper } from "@/components/shared";
import { LoginForm } from "@/components/forms";
import { TitleMixin } from "@/mixins";

/**
 * Login view
 */
export default {
  name: "Login",
  /**
   * Title of view
   */
  mixins: [TitleMixin],
  /**
   * -------------- Components --------------
   */
  components: {
    AuthFormsWrapper,
    LoginForm,
  },
};
</script>
